// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showing-feedback-form-container {
  display: flex;
  padding: 80px 140px;
  align-self: center;
  font-family: "Roboto", sans-serif;
  animation: fadeIn 1s;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.showing-feedback-form-container .showing-feedback-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 500px;
  height: 100vh;
}
.showing-feedback-form-container .showing-feedback-form .loading {
  width: 500px;
}
.showing-feedback-form-container .showing-feedback-form > input, .showing-feedback-form-container .showing-feedback-form button {
  width: 500px;
}
.showing-feedback-form-container .showing-feedback-form .logo {
  align-self: flex-start;
}
.showing-feedback-form-container .showing-feedback-form .header, .showing-feedback-form-container .showing-feedback-form .subheader {
  margin: 0;
  font-family: "Proxima Nova", sans-serif;
}
.showing-feedback-form-container .showing-feedback-form .header {
  font-size: 32px;
  color: var(--secondary-color-1);
  font-weight: 700;
}
.showing-feedback-form-container .showing-feedback-form .subheader {
  font-size: 21px;
  line-height: 28px;
  font-weight: 400;
  color: var(--secondary-color-3);
}
.showing-feedback-form-container .showing-feedback-form .form-input > label {
  font-size: 14px;
  font-weight: 600;
  color: var(--secondary-color-5);
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.showing-feedback-form-container .showing-feedback-form .rating {
  display: flex;
  column-gap: 10px;
  position: relative;
  width: -moz-fit-content;
  width: fit-content;
}
.showing-feedback-form-container .showing-feedback-form .rating > div {
  height: 30px;
  cursor: pointer;
}
.showing-feedback-form-container .showing-feedback-form .rating > div:first-child::before, .showing-feedback-form-container .showing-feedback-form .rating > div:last-child::before {
  position: absolute;
  bottom: -15px;
  font-weight: 600;
  color: var(--secondary-color-5);
  font-size: 10px;
}
.showing-feedback-form-container .showing-feedback-form .rating > div:first-child::before {
  left: 0;
}
.showing-feedback-form-container .showing-feedback-form .rating > div:last-child::before {
  right: 0;
}
.showing-feedback-form-container .showing-feedback-form .rating > div > svg {
  transition: 0.2s all ease-in-out;
}
.showing-feedback-form-container .showing-feedback-form .rating.interest > div:first-child::before {
  content: "Not at All";
}
.showing-feedback-form-container .showing-feedback-form .rating.interest > div:last-child::before {
  content: "Very Much";
}
.showing-feedback-form-container .showing-feedback-form .rating.expi > div:first-child::before {
  content: "Bad";
}
.showing-feedback-form-container .showing-feedback-form .rating.expi > div:last-child::before {
  content: "Excellent";
}
.showing-feedback-form-container .showing-feedback-form .rating.opinion > div:first-child::before {
  content: "Too Much";
}
.showing-feedback-form-container .showing-feedback-form .rating.opinion > div:last-child::before {
  content: "Best Value";
}
.showing-feedback-form-container .showing-feedback-form .rating.listing > div:first-child::before {
  content: "Worst";
}
.showing-feedback-form-container .showing-feedback-form .rating.listing > div:last-child::before {
  content: "Best";
}
.showing-feedback-form-container .illus {
  height: 200px;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Response/modules/ShowingFeedbackForm/showingFeedbackForm.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AADJ;AAEI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;AAAR;AACQ;EACI,YAAA;AACZ;AACQ;EACI,YAAA;AACZ;AACQ;EACI,sBAAA;AACZ;AACQ;EACI,SAAA;EACA,uCAAA;AACZ;AACQ;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;AACZ;AACQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,+BAAA;AACZ;AAEU;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAd;AAGM;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EAAA,kBAAA;AADR;AAEQ;EACI,YAAA;EACA,eAAA;AAAZ;AACY;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAChB;AACY;EACI,OAAA;AAChB;AACY;EACI,QAAA;AAChB;AACY;EACI,gCAAA;AAChB;AAIgB;EACI,qBAAA;AAFpB;AAMgB;EACI,oBAAA;AAJpB;AAUgB;EACI,cAAA;AARpB;AAYgB;EACI,oBAAA;AAVpB;AAgBgB;EACI,mBAAA;AAdpB;AAkBgB;EACI,qBAAA;AAhBpB;AAsBgB;EACI,gBAAA;AApBpB;AAwBgB;EACI,eAAA;AAtBpB;AA4BI;EACI,aAAA;AA1BR;AA4BI;EACI;IAAK,UAAA;EAzBX;EA0BM;IAAO,UAAA;EAvBb;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.showing-feedback-form-container {\n    display: flex;\n    padding: 80px 140px;\n    align-self: center;\n    font-family: \"Roboto\", sans-serif;\n    animation: fadeIn 1s;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    .showing-feedback-form {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        max-width: 500px;\n        height: 100vh;\n        .loading {\n            width: 500px;\n        }\n        > input, button {\n            width: 500px;\n        }\n        .logo {\n            align-self: flex-start;\n        }\n        .header, .subheader { \n            margin: 0;\n            font-family: 'Proxima Nova', sans-serif;                                             \n        }\n        .header {\n            font-size: 32px;\n            color: var(--secondary-color-1);\n            font-weight: 700;\n        }\n        .subheader {\n            font-size: 21px;\n            line-height: 28px;\n            font-weight: 400;\n            color: var(--secondary-color-3);\n        }\n        .form-input {\n          > label {\n              font-size: 14px;\n              font-weight: 600;\n              color: var(--secondary-color-5);\n              display: flex;\n              align-items: center;\n              margin-bottom: 5px;\n          }\n      }\n      .rating {\n        display: flex;\n        column-gap: 10px;\n        position: relative;\n        width: fit-content;\n        > div {\n            height: 30px;\n            cursor: pointer;\n            &:first-child::before, &:last-child::before { \n                position: absolute;\n                bottom: -15px;\n                font-weight: 600;\n                color: var(--secondary-color-5);\n                font-size: 10px;\n            }\n            &:first-child::before {\n                left: 0;\n            }\n            &:last-child::before {\n                right: 0;\n            }\n            > svg {\n                transition: .2s all ease-in-out;\n            }\n        }\n        &.interest > div {\n            &:first-child { \n                &::before{\n                    content: \"Not at All\";\n                }\n            }\n            &:last-child { \n                &::before{\n                    content: \"Very Much\";\n                }\n            }\n        }\n        &.expi > div {\n            &:first-child { \n                &::before{\n                    content: \"Bad\";\n                }\n            }\n            &:last-child { \n                &::before{\n                    content: \"Excellent\";\n                }\n            }\n        }\n        &.opinion > div {\n            &:first-child { \n                &::before{\n                    content: \"Too Much\";\n                }\n            }\n            &:last-child { \n                &::before{\n                    content: \"Best Value\";\n                }\n            }\n        }\n        &.listing > div {\n            &:first-child { \n                &::before{\n                    content: \"Worst\";\n                }\n            }\n            &:last-child { \n                &::before{\n                    content: \"Best\";\n                }\n            }\n        }\n      }\n    }\n    .illus {\n        height: 200px;\n    }\n    @keyframes fadeIn {\n        0% { opacity: 0; }\n        100% { opacity: 1; }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
